import * as fnsLocales from 'date-fns/locale';
import { LocaleListEntry } from './types';

// Map of language variants which are not supported by date-fns like e.g.
// Swiss German (probably because for dates there is e.g. no difference between
// German and Swiss German). For number formatting we use Intl.NumberFormat
// so these variants are relevant in that context.
export const locales = {
  ...fnsLocales,
  deCH: { ...fnsLocales.de, code: 'de-CH' },
};

const capitalizeFirst = (str: string, localeCode: string): string => {
  const firstCode = str.codePointAt(0) ?? 0;
  // Georgian Mkhedruli (U+10D0–U+10FF) has no standard uppercase equivalent in
  // modern Georgian text — skip capitalization for these characters.
  if (firstCode >= 0x10d0 && firstCode <= 0x10ff) return str;
  return str.charAt(0).toLocaleUpperCase(localeCode) + str.slice(1);
};

export const localeList: LocaleListEntry[] = Object.values(locales)
  .filter(locale => locale.code)
  .map(locale => ({
    locale,
    code: locale.code,
    name: capitalizeFirst(
      new Intl.DisplayNames(locale.code, { type: 'language' }).of(locale.code)!,
      locale.code
    ),
  }));

export const localeByCodeOrDefault = (code: string) =>
  localeList.find(locale => locale.code === code)?.locale ||
  ARDOQ_DEFAULT_LOCALE;

export const ARDOQ_DEFAULT_LOCALE = locales.enUS;
